export function orderCollection(items, id, fromOrder, toOrder, filter) {
  return items.map(element => {
    if (filter && !filter(element)) {
      return element;
    }

    if (element.id.toString() === id.toString()) {
      return {
        ...element,
        order: toOrder,
      };
    }

    if (element.order >= toOrder && element.order < fromOrder) {
      return {
        ...element,
        order: element.order + 1,
      };
    }

    if (element.order <= toOrder && element.order > fromOrder) {
      return {
        ...element,
        order: element.order - 1,
      };
    }

    return element;
  });
}

export function orderCollectionPostDelete(items, deletedOrder) {
  return items.map(element => {
    if (element.order > deletedOrder) {
      return {
        ...element,
        order: element.order - 1,
      };
    }

    return element;
  });
}



// WEBPACK FOOTER //
// ./src/utils/ordering.js